import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DefectMedia } from "../models/defect.model";
import { PhotoViewModel } from "../models/open-defect-table.models";

@Injectable({
	providedIn: "root",
})
export class PhotoViewModelService {
	constructor(private sanitizer: DomSanitizer) {}

	public buildPhotoViewModel(images: DefectMedia[]): PhotoViewModel[] {
		return images.map((image: DefectMedia) => {
			return {
				mediaId: image.mediaId,
				mediaType: image.mediaType,
				thumbnail: image.thumbnail,
				sanitizedImage: this.sanitizer.bypassSecurityTrustResourceUrl(
					`data:image/${image.mediaType};base64,${image.thumbnail}`,
				),
			} as PhotoViewModel;
		});
	}
}
